import React from 'react';

interface ComponentProps extends React.HTMLAttributes<HTMLDivElement> {
  htmlContent: string;
}

function RenderHtmlContentDescriptions({ htmlContent, className, ...rest }: ComponentProps) {
  return (
    <div
      className={`html-content ${className || ''}`}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
      {...rest}
    />
  );
}

export default RenderHtmlContentDescriptions;
